import cn from 'classnames'
import { LoginStatuses, paths, useAuth, useLogoutQry } from 'mmfintech-backend-api'
import { tr, useWindowSize } from 'mmfintech-commons'
import type React from 'react'
import { useEffect, useState } from 'react'
import { NavLink, useHistory } from 'react-router-dom'
import BrandLogo from './BrandLogo'
import MainMenuItems from './MainMenuItems'
import UserDropDownMenu from './UserDropDownMenu'
import UserMenuItems from './UserMenuItems'

import './Header.scss'

const MAX_MOBILE_WIDTH = 1176

function Header() {
  const [opened, setOpened] = useState(false)

  const userStatus = useAuth()
  const isLoggedIn = userStatus === LoginStatuses.LOGGED_IN

  const history = useHistory()

  const [width] = useWindowSize()
  const isHamburgerVisible = width < MAX_MOBILE_WIDTH

  const { logout } = useLogoutQry(false, () => {
    history.push(paths.login())
  })

  function hideMenu() {
    return opened && setOpened(false)
  }

  function handleLogoutClick(e: React.BaseSyntheticEvent) {
    e.preventDefault()
    hideMenu()
    void logout()
    return false
  }

  useEffect(() => {
    width > MAX_MOBILE_WIDTH && hideMenu()
    // eslint-disable-next-line
  }, [width])

  useEffect(() => {
    const body = document.getElementsByTagName('body').item(0)
    if (body) {
      if (opened) {
        body.classList.add('menu-opened')
      } else {
        body.classList.remove('menu-opened')
      }
    }
    // eslint-disable-next-line
  }, [opened])

  return (
    <div className='header-wrapper'>
      {opened && <div className='overlay' onClick={hideMenu} />}

      <nav className='header-container'>
        <BrandLogo />

        {!isHamburgerVisible && isLoggedIn && (
          <div className='header-inner-container'>
            <MainMenuItems onHideMenu={hideMenu} />
          </div>
        )}

        {isHamburgerVisible ? (
          <div className='header-inner-container'>
            <div className='hamburger'>
              <button type='button' className='hamburger-icon' onClick={() => setOpened(prevState => !prevState)}>
                <span className='menu-icon' />
              </button>

              <nav className={cn('hamburger-menu', { open: opened })}>
                {isLoggedIn && <MainMenuItems onHideMenu={hideMenu} />}
                {isLoggedIn && <UserMenuItems onClick={hideMenu} />}
                {isLoggedIn && (
                  <NavLink to='#' onClick={handleLogoutClick}>
                    {tr('PORTAL.HEADER.LOGOUT', 'Log out')}
                  </NavLink>
                )}
                {!isLoggedIn && (
                  <NavLink to={paths.login()} onClick={hideMenu}>
                    {tr('PORTAL.HEADER.LOGIN', 'Log in')}
                  </NavLink>
                )}
                {!isLoggedIn && (
                  <NavLink to={paths.signUp()} onClick={hideMenu}>
                    {tr('PORTAL.HEADER.SIGNUP', 'Sign up free')}
                  </NavLink>
                )}
              </nav>
            </div>
          </div>
        ) : (
          <div className='header-inner-container'>
            {isLoggedIn && <UserDropDownMenu UserMenuItems={UserMenuItems} />}
          </div>
        )}
      </nav>
    </div>
  )
}

export default Header
